<template>
    <div class="content">
        <h2>立案报告</h2>
        
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="案件来源:" prop="ajly">
                        <el-select v-model="form.ajly" placeholder="请选择案件来源" size="small">
                            <el-option
                                v-for="dict in lyOptions"
                                :key="dict.id"
                                :label="dict.ajly"
                                :value="dict.ajly"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="14">
                    <el-form-item label="受理日期:"  prop="shoulirq">
                            <el-date-picker size="small"
                                v-model="form.shoulirq"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="10" style="text-align:right;">
                    <el-button type="primary" size="small" @click="getTuili">推理</el-button>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="案情摘要:" prop="anqingzhaiyao">
                        <el-input type="textarea" rows="7" v-loading="loadingTl"
                        v-model="form.anqingzhaiyao"
                        placeholder="请输入案情摘要"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="法律:" prop="falv">
                        <el-input type="textarea" rows="5"
                        v-model="form.falv"
                        placeholder="请输入违反法律"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="立案日期:"  prop="lianRq">
                            <el-date-picker size="small"
                                v-model="form.lianRq"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="监督员1:" prop="jdy1">
                        <el-select v-model="form.jdy1" size="small" placeholder="请选择" :key="Math.random()">
                            <el-option
                            v-for="(item, index) in options"
                            :key="index"
                            :label="item.xm"
                            :value="item.xm">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="监督员2:" prop="jdy2">
                        <el-select v-model="form.jdy2" size="small" placeholder="请选择" :key="Math.random()">
                            <el-option
                            v-for="(item, index) in options"
                            :key="index"
                            :label="item.xm"
                            :value="item.xm">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col :span="24">
                    <el-form-item label="签名方式:" prop="qmfs">
                        <el-radio-group v-model="form.qmfs">
                            <el-radio :label="1">电子签名及日期</el-radio>
                            <el-radio :label="2">手工签名无日期</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>-->
                <el-col :span="24">
                    <el-form-item label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit('form')">生成立案报告</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <!--<el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>-->
                    </el-form-item>
                </el-col>
            </el-row>            
        </el-form>


        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="立案报告" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    props:['code','mid','pcId','ajla','jdy1','jdy2','ajlaList','ajdcbg'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            sheng:'',
            xianqu:'',
            jcjg:'',
            form:{
                ajla_lsh:'',
                ajly:'',
                shoulirq:'',
                anqingzhaiyao:'',
                falv:'',
                lianRq:'',
                jdy1:'',
                jdy2:'',
                qmfs:1,
            },
            ajlaLsh:'',
            rules:{
                ajly:[
                    { required: true, message: '案件来源不能为空', trigger: 'blur' }
                ],
                shoulirq:[
                    { required: true, message: '受理日期不能为空', trigger: ['change','blur'] }
                ],
                falv:[
                    { required: true, message: '违反法律不能为空', trigger: ['change','blur'] }
                ],
                anqingzhaiyao:[
                    { required: true, message: '案情摘要不能为空', trigger: 'blur' }
                ],
                lianRq:[
                    { required: true, message: '立案日期不能为空', trigger: ['change','blur'] }
                ],
                jdy1:[
                    { required: true, message: '监督员1不能为空', trigger: ['change','blur'] }  
                ],
                jdy2:[
                    { required: true, message: '监督员2不能为空', trigger: ['change','blur'] }  
                ],
                qmfs:[
                    { required: true, message: '签名方式不能为空', trigger: 'blur' }
                ]
            },
            lyOptions:[],
            open:false,
            form2:{
                jcnr:''
            },
            wsUrl:'',
            isWs:false,
            options:[],         
            zfmbList:[],
            isActive:'0',
            isActive2:'-1',
            zfXX:[],
            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            baseUrl:'',
            loadingTl:false,
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.sheng = user.sheng
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.jcjg = user.jcjg
        this.baseUrl = user.baseUrl
        this.getJdys(this.cmid)
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getajly`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                pcId:this.pcId,
            }
        })
        .then(response => {
            console.log(response.data);
            this.lyOptions = response.data.data || []
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
        this.getList()            
    },
    async mounted() {
    },
    methods: {
        getTuili(){
            this.loadingTl = true
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/otherInferences`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    mid:this.mid,
                    lsh:this.pcId,
                    templateName:this.code
                }
            })
            .then(response => {
                console.log(response.data,1081);
                if(response.data.code == 0 && response.data.data){
                    let str = response.data.data.answer || '';
                    this.$set(this.form,'anqingzhaiyao',str)
                }else{
                    this.$message.error(response.data.msg);
                }
                this.loadingTl = false
            })
            .catch(error => {
                this.loadingTl = false
                this.$message.error('推理失败！'|| error);
                console.error('There was an error!', error);
            });
        },
        // 初始化
        initBlForms() {
            let date = new Date()
            let rq = this.getDate(date,'yyyy-MM-dd')
            this.$set(this.form,'shoulirq',rq)
            this.$set(this.form,'lianRq',rq)
            let text = this.ajla ? this.ajla : ''
            this.$set(this.form,'anqingzhaiyao',text)
            this.$set(this.form,'jdy1',this.jdy1)
            this.$set(this.form,'jdy2',this.jdy2)
            if(this.ajdcbg && this.ajdcbg.data.length>0){
                let arr = this.ajdcbg.data
                let falv = ''
                arr.forEach(item=>{
                    falv += item.wffl + '；'
                })
                this.$set(this.form,'falv',falv)
            }
        },
        getJdys(cmid){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/lawEnforcer`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:cmid
                }
            })
            .then(async response => {
                this.options = response.data.data
            })
            .catch(error => {
                this.$message.error('获取监督员数据失败！');
                console.error('There was an error!', error);
            });
        },
        getList(){
            console.log(this.ajlaList,246)
            if(this.ajlaList){
                this.$set(this.form,'ajly',this.ajlaList.ajly || '')
                this.$set(this.form,'shoulirq',this.ajlaList.shoulirq || '')
                this.$set(this.form,'lianRq',this.ajlaList.lianRq || '')
                this.$set(this.form,'anqingzhaiyao',this.ajlaList.anqingzhaiyao || '')
                this.$set(this.form,'jdy1',this.ajlaList.zhubanRenyuan || '')
                this.$set(this.form,'jdy2',this.ajlaList.xiebanRenyuan || '')
                this.$set(this.form,'falv',this.ajlaList.falv || '')
                this.isWs = true
                this.wsUrl = this.ajlaList.url
                this.ajlaLsh = this.ajlaList.ajla_lsh
            }else{
                this.initBlForms()
            }
        },
        getWenshu(){  
            this.isWs = false 
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/selectWenshu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh: this.pcId,
                    wsName:'案件立案'
                }
            })
            .then(response => {
                if(response.data.code==0){
                    if(response.data.msg){ 
                        this.isWs = true
                        let ws = response.data.msg
                        this.wsUrl = ws
                    }else{
                        this.isWs = false
                    }
                }else{
                    this.isWs = false
                }
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });          
        },
        show(){
            if(this.wsUrl){
                let ws = this.wsUrl
                if(ws){
                    let url = this.$router.resolve({
                        path:'/pdf2',
                        query:{
                            wsname:'lianbaogao',
                            ws:encodeURIComponent(ws) // 手动 encode 一次
                        }
                    })
                    window.open(url.href,'_blank')
                }else{
                    this.$message.error('暂未制作本文书，不能预览！') 
                }
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                let url = this.wsPdf
                window.open(url,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            let wsname = 'anjianshoulijilu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.form2.jcnr.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            if(itema.mc.indexOf('<br/>') != -1){
              itema.mc = itema.mc.replace(/<br\s*\/?>/gi, '\n');
            }
            if(this.form2.jcnr){
              let zf = this.form2.jcnr.substr(this.form2.jcnr.length - 1,1)
              let nr = zf != '\n' ? '\n' +  itema.mc : itema.mc
              this.form2.jcnr =  this.form2.jcnr + nr
            }else{
              this.form2.jcnr = itema.mc
            }
          }
        },
        submit(form){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log(this.form,725)
                    let that = this
                    this.loading = true

                    axios({
                        method: 'post',
                        url: this.baseUrl+`/xx/makeWenshu`,
                        data:{
                            lsh: this.pcId,
                            wsName:'案件立案',
                            ajlaLsh:this.form.ajla_lsh,
                            ajly:this.form.ajly,
                            shoulirq:this.getDate(this.form.shoulirq,'yyyy-MM-dd'),
                            anqingzhaiyao:this.form.anqingzhaiyao,
                            falv:this.form.falv,
                            lianRq:this.getDate(this.form.lianRq,'yyyy-MM-dd'),
                            supervisorOne:this.form.jdy1,
                            supervisorTwo:this.form.jdy2,
                            qmfs:this.form.qmfs,                           
                            cmid:this.cmid,
                            xm:this.xm,
                            dm:this.dm,
                            shi:this.shi,
                            xianqu:this.xianqu,
                            jcjg:this.jcjg
                        },
                        headers: { 
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        console.log(res,809)
                        this.loading = false
                        if(res.data.code == 0 && res.data.data){
                            this.isWs = true
                            this.wsUrl = res.data.data.url
                            this.$set(this.form,'ajla_lsh',res.data.data.lsh)
                            
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.show()
                        }else{
                            if(res.data.msg){
                                this.$message.error(res.data.msg)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                    
                }
            })
        }
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.content >>> .el-textarea.is-disabled .el-textarea__inner ,.content >>> .el-input.is-disabled .el-input__inner{ color: #333;}
.zfmb{ border:1px solid #DCDFE6; padding: 20px;max-height: 500px; overflow-y: auto;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../../assets/images/wjj.png) no-repeat center left; margin-left: 10px;}
.zfmb2 span.dqSpan{color:#0C80E8;}
.zfmb2 span b{ display: none; position: absolute; top:40px;left: 120px; width: 600px; font-weight: normal; background:#303133; color: #fff;padding: 5px 10px;
    border-radius: 6px;}
.zfmb2 span:hover b{ display: block;}
.content >>> .el-form-item {
    margin-bottom: 12px !important;
}
.content >>> .el-loading-spinner{top: 40px !important;}
</style>